import React, { useCallback, useState } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import {
  CustomButton,
  CustomCard,
  CustomCopyToClipboard,
  CustomIconButton,
} from "../../../../../../../../Components";
import { getDownloadableLink } from "../../../../../../../../Helper";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { AllCourseRelatedToAgentDialog } from "../AllCourseRelatedToAgentDialog";
import { GetCoursesDetails } from "../../../../../../../../Services";
import { CourseDetailsDialog } from "../CourseDetailsDialog";

// styles
import useStyle from "./styles";

// icons
import { ArrowUpRight } from "../../../../../../../../assets/icons";

function AgentCard({ data, key }) {
  const styles = useStyle();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const [showAllCourseDialog, setShowAllCourseDialog] = useState(false);
  const [details, setDetails] = useState({});
  const [isOpenCourseDeatilsDialog, setIsOpenCourseDeatilsDialog] =
    useState(false);
  const toggleShowAll = () => {
    setShowAllCourseDialog(true);
  };

  const getCoursesDetails = useCallback(async (courseId) => {
    try {
      const response = await GetCoursesDetails(courseId);
      setDetails(response);
      setIsOpenCourseDeatilsDialog(true);
    } catch (error) {
      console.error("Failed to fetch courses:", error);
    } finally {
    }
  }, []);

  return (
    <>
      <CustomCard
        boxShadow="xs"
        borderRadius="xl"
        borderColor="secondary"
        classes={styles.containerCardAgent}
      >
        <Box className={styles.containerImgName}>
          <Box className={styles.wrapperImgProf}>
            <img
              className={styles.fullWidth}
              src={getDownloadableLink(data?.userProfileImage)}
              alt={translate("Profile-Image")}
            />
          </Box>
          <Box className={styles.containerHeaderInfo}>
            <Typography className={styles.agentNameTitle}>
              {data?.agentName}
            </Typography>
            <CustomCopyToClipboard
              data={data?.staffCode}
              childrenData={"#" + data?.staffCode}
              copyDoneShowTime={1000}
            />
          </Box>
        </Box>
        <Divider className={styles.divider}></Divider>
        {data?.courseList?.length > 0 && (
          <Box className={styles.containerCourses}>
            {data?.courseList?.slice(0, 2).map((course, index) => (
              <Box key={index} className={styles.containerCourse}>
                <Box className={styles.containerHeaderCourse}>
                  <Typography className={styles.courseNameTitle}>
                    {course?.courseName}
                  </Typography>
                  <CustomIconButton
                    variant="text"
                    size="xs"
                    boxShadow="none"
                    color="secondary"
                    onClick={() => {
                      getCoursesDetails(191);
                    }}
                  >
                    <ArrowUpRight
                      width="20"
                      height="20"
                      fill={palette.button.secondaryGray_fg}
                    />
                  </CustomIconButton>
                </Box>
                <Box className={styles.courseDesc}>
                  {`matchWith ${course?.matchWith}`}
                </Box>
              </Box>
            ))}
          </Box>
        )}
        {data.courseList.length > 2 && (
          <Box className={styles.conatinerShowMore}>
            <CustomButton
              boxShadow="none"
              size="sm"
              variant="text"
              color="tertiary"
              style={{ minWidth: "fit-content" }}
              onClick={toggleShowAll}
            >
              {translate("View-More")}
            </CustomButton>
          </Box>
        )}
      </CustomCard>
      {showAllCourseDialog && (
        <AllCourseRelatedToAgentDialog
          onOpen={showAllCourseDialog}
          onClose={() => {
            setShowAllCourseDialog(false);
          }}
          data={data}
        />
      )}
      {isOpenCourseDeatilsDialog && (
        <CourseDetailsDialog
          onOpen={isOpenCourseDeatilsDialog}
          onClose={() => {
            setIsOpenCourseDeatilsDialog(false);
          }}
          detailsCourse={details}
        />
      )}
    </>
  );
}

export default AgentCard;
